import React, { memo } from 'react';
import { Cell, FieldGroupItem, FieldGroupVariant, Row } from '@dexma/ui-components';
import { StyledWidgetSelector } from 'adapter/in/common/components/Selector/style';

import gtmIds from 'adapter/in/dashboards/config/gtm';
import { ENTITY_TYPE } from 'adapter/in/common/config/entityTypes';
import { StyledFieldGroup, StyledFieldGroupCell } from 'adapter/in/common/components/FieldGroup/style';
import { SelectorOption, SelectorValueOptions } from 'adapter/in/common/form/types';
import { FooterInputText } from 'adapter/in/common/components/Text';

export type WidgetFieldGroup = {
    label: string;
    name: string;
    options: FieldGroupItem[];
    value: SelectorValueOptions | undefined;
    isLoading: boolean;
    error: boolean;
    onChange: (data: any) => void;
    errorMessage?: string;
    variant: FieldGroupVariant;
    style?: React.CSSProperties;
    footer?: string;
};

const loadingOptions: FieldGroupItem[] = [
    { value: 'no', label: 'd', id: 'd', isDisabled: true },
    { value: 'no', label: 'h', id: 'h', isDisabled: true },
    { value: 'no', label: 'm', id: 'm', isDisabled: true },
];
const getSelectedValues = (value: SelectorValueOptions) =>
    Array.isArray(value) ? value?.map((element) => element.id)[0] : ((value as unknown) as SelectorOption).id;

const mapAsValue = (items: FieldGroupItem[]) => items.map((item: FieldGroupItem) => item.id);

const FormFieldGroup = memo((props: WidgetFieldGroup) => {
    const { label, onChange, options, value, isLoading, error, errorMessage, name, variant, style, footer } = props;
    // eslint-disable-next-line no-nested-ternary
    const selectedValues = value ? getSelectedValues(value) : '';
    return (
        <StyledWidgetSelector $error={!isLoading && error} data-testid='field-group-wrapper' style={style}>
            <Row>
                <Cell className='widget-type-block'>
                    <span>{label}</span>
                </Cell>
            </Row>
            <Row>
                <StyledFieldGroupCell data-entity-id={label?.replaceAll(' ', '_').toLowerCase()} data-entity-type={ENTITY_TYPE.FORM_FIELD}>
                    <StyledFieldGroup
                        name={name}
                        variant={variant}
                        className={`field_group_${name}`}
                        dataId={gtmIds.addWidget.sidePanel.form.select}
                        onChange={onChange}
                        $isLoading={isLoading}
                        selectedValues={isLoading ? mapAsValue(loadingOptions)[0] : selectedValues!}
                        values={isLoading ? loadingOptions : options}
                    />
                    {!isLoading && error && <div className='error'>{errorMessage} </div>}
                </StyledFieldGroupCell>
            </Row>
            {footer && <FooterInputText text={footer} />}
        </StyledWidgetSelector>
    );
});

export default FormFieldGroup;
